export var TreatmentLocation;
(function (TreatmentLocation) {
    TreatmentLocation["VIDEO_CALL"] = "Videotherapie";
    TreatmentLocation["IN_PRESENCE"] = "Praxistermin";
})(TreatmentLocation || (TreatmentLocation = {}));
//# sourceMappingURL=treatment-location.enum.js.map